import _get from 'lodash/get';

/** @return {import("zod").z.infer<typeof import('./stubs').FORM_SCHEMA>} */
export function createFormData(data, hasExchangesConfigTask = false) {
  return {
    id: _get(data, 'id', ''),
    isEnabled: _get(data, 'is_enabled', false),
    isAddedToDoLater: hasExchangesConfigTask
  };
}
